import * as S from './styles'

const Preloader = () => (
   <S.Wrapper>
      <S.Loader>
         <div />
         <div />
         <div />
         <div />
         <div />
         <div />
         <div />
         <div />
      </S.Loader>
   </S.Wrapper>
)

export default Preloader